import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { reducer as formReducer } from "redux-form";
import {
    persistStore,
    persistReducer,
    REGISTER,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import auth from "./auth";
import company from "./company";
import profile from "./profile";
import verification from "./verification";
import newMessage from "./message/newMessage";
import exchange from "reducers/exchange";
import conversations from "reducers/conversations";
import notifications from "reducers/notification";
import settings from "reducers/settings";
import mainPageSearch from "store/mainPageSearch";
import contacts from "reducers/contacts";

const persistConfig = {
    key: "root",
    version: 1,
    whitelist: ["auth", "profile", "company", "settings"],
    storage,
};

const appReducer = combineReducers({
    form: formReducer,
    auth,
    company,
    profile,
    // Статус верификации не персистим — он должен быть свежим при каждом входе в профиль
    verification,
    exchange,
    conversations,
    notifications,
    settings,
    contacts,
    mainPageSearch,
    newMessage,
});

const reducers = (state, action) => {
    // TODO move this check to signOut action after all store will be redux toolkit
    if (action.type === "auth/signOut/fulfilled") {
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
                ignoredPaths: ["form", "conversations", "notifications", "contacts"],
            },
            immutableCheck: {
                ignoredPaths: ["conversations", "notifications", "contacts"],
            },
        }),
});

const persistor = persistStore(store);

export { store, persistor };
